<template>
  <div>
    <the-nav-bar :title="$t('createPost.detail')" />
    <div class="body-wrapper">
      <md-scroll-view :scrolling-x="false" auto-reflow ref="scrollView">
        <div class="scroll-body">
          <div class="info row-align-center">
            {{ $t('createPost.editInfo') }}
          </div>
          <div class="field">
            <div
              class="field-item row-justify-center"
              v-for="key of fieldItemList"
              :key="key"
            >
              <div class="field-item-title">{{ $t(`createPost.${key}`) }}</div>
              <div class="field-item-content">
                {{ getText(`${key}Text`) }}
              </div>
              <!-- <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div> -->
            </div>
          </div>
          <div class="input-panel">
            <div class="input-panel-item">
              <div class="panel-item-title row-align-center">
                <svg class="icon">
                  <use xlink:href="#icon-smile" />
                </svg>
                <span>{{ $t('createPost.headline') }}</span>
              </div>
              <div class="panel-item-content">
                <md-input-item
                  type="text"
                  class="input-item"
                  placeholder="Hi,TIGA"
                  v-model.trim="title"
                  :maxlength="100"
                  readonly
                ></md-input-item>
              </div>
            </div>
            <div class="input-panel-item">
              <div class="panel-item-title row-align-center">
                <svg class="icon">
                  <use xlink:href="#icon-smile" />
                </svg>
                <span>{{ $t('createPost.termsOfTrade') }}</span>
              </div>
              <div class="panel-item-content">
                <md-textarea-item
                  class="textarea-item"
                  v-model="provisions"
                  placeholder="Hi,TIGA"
                  rows="3"
                  readonly
                ></md-textarea-item>
              </div>
            </div>
          </div>
        </div>
      </md-scroll-view>
    </div>
    <div class="btn-wrapper" v-show="isLoaded">
      <md-button
        class="btn"
        :type="isBtnDisabled ? 'disabled' : 'primary'"
        @click="onChangeClickPre"
      >
        <span v-if="adStore.status == 'on'">{{
          $t('createPost.takeOff')
        }}</span>
        <span v-else-if="adStore.status == 'off'">{{
          $t('createPost.putOn')
        }}</span>
      </md-button>
      <md-button
        class="btn btn-edit"
        :type="isEditBtnDisabled ? 'disabled' : 'primary'"
        plain
        @click="goEditAd"
      >
        <span>{{ $t('common.edit') }}</span>
      </md-button>
    </div>

        <md-dialog
          :title="this.$t('common.coWarnTitle')"
          :closable="false"
          v-model="lossDialog.open"
          :btns="lossDialog.btns"
        >
            {{$t('common.coWarnText1')}}
            <span style="font-weight:bold;color:red;">
            {{$t('common.coWarnText2')}}
            </span> 
            <span style="color:red;">
            {{$t('common.coWarnText3')}}
            </span>
            <span style="font-weight:bold;">
              {{$t('common.adjustFeeText')}}
            </span>
            <p style="margin-top: 5px;"></p>
              <md-agree
                v-model="agreeConf.checked"
                :disabled="agreeConf.disabled"
                :size="agreeConf.size"
                icon-type="square"
                @change="onAgreeChange(agreeConf.checked, $event)"
              >
                  {{$t('common.knownAgree')}}
                <a style="text-decoration: none;" href="javascript:void(0)" @click="showAgreement()" >《{{ $t('global.login.agreementName') }}》</a>
              </md-agree>
        
        </md-dialog>


  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Icon,
  ScrollView,
  InputItem,
  TextareaItem,
  Button,
  Popup,
  PopupTitleBar,
  Dialog,
  Toast,
  Agree,
} from 'mand-mobile';
import { mapState } from 'vuex';
import putChangeStatus from '@/api/put-change-status';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [Icon.name]: Icon,
    [ScrollView.name]: ScrollView,
    [InputItem.name]: InputItem,
    [TextareaItem.name]: TextareaItem,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Dialog.name]: Dialog,
    [Agree.name]: Agree,
  },
  data() {
    return {
      agreeConf: {
        checked: false,
        name: 'agreeRisk',
        size: 'md',
        disabled: false,
        introduction: '风险须知同意',
      },
      lossDialog: {
        open: false,
        btns: [
          {
            text: this.$t('common.cancel'),
          },
          {
            text: this.$t('common.confirm'),
            warning: true,
            handler: this.onLossConfirm,
          },
        ],
      },
      isLoaded: false,
      id: '',
      title: '',
      provisions: '',
      fieldItemList: [
        'adType',
        'attribute',
        'crypto',
        'payment',
        'fiatCurrency',
        'customizePrice',
        'tradeAmount',
        'location',
        'standardHours',
        'trader',
      ],
      isSubmitting: false,
      isEditSubmitting: false,
    };
  },
  computed: {
    ...mapState({
      settings: state => state.settings,
      adStore: state => state.adStore,
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
      navLangMain: state => state.navLangMain,
    }),
    adTypeText() {
      const { adType } = this.adStore;
      return (adType && this.$t(`createPost.${adType}`)) || '';
    },
    attributeList() {
      return [
        {
          value: 0,
          text: this.$t('createPost.public'),
        },
        {
          value: 1,
          text: this.$t('createPost.private'),
        },
      ];
    },
    attributeText() {
      const { attribute } = this.adStore;
      const item = this.attributeList.find(item => item.value === attribute);
      return (item && item.text) || '';
    },
    cryptoList() {
      return this.settings.cryptoList.map(item => {
        return {
          value: item.id,
          text: `${item.name} (${item.symbol})`,
        };
      });
    },
    cryptoText() {
      const { crypto } = this.adStore;
      const obj = this.cryptoList.find(item => {
        return item.value == crypto;
      });
      return (obj && obj.text) || '';
    },
    paymentList() {
      return this.settings.paymentList.map(item => {
        return {
          value: item.id,
          text: this.$t(`payments.${item.name}`),
        };
      });
    },
    paymentText() {
      const { payment } = this.adStore;
      const arr = [];
      this.paymentList.forEach(item => {
        if (payment.includes(item.value)) {
          arr.push(item.text);
        }
      });
      return this.navLang == 'en' ? arr.join(',') : arr.join('，');
    },
    fiatCurrencyList() {
      return this.settings.legalCurrencyList.map(item => {
        return {
          value: item.id,
          text: `${item.unit} (${item.unit})`,
        };
      });
    },
    fiatCurrencyText() {
      const { fiatCurrency } = this.adStore;
      const obj = this.fiatCurrencyList.find(item => {
        return item.value == fiatCurrency;
      });
      return (obj && obj.text) || '';
    },
    locationList() {
      return this.settings.locationList.map(item => {
        return {
          value: item.id,
          text: this.$root.countries.getName(item.name, this.navLangMain),
        };
      });
    },
    locationText() {
      const { location } = this.adStore;
      const obj = this.locationList.find(item => {
        return item.value == location;
      });
      return (obj && obj.text) || '';
    },
    customizePriceText() {
      const {
        isFixed,
        fixedPrice,
        reference,
        isAbove,
        percentage,
        difference,
      } = this.adStore;
      if (isFixed) {
        return fixedPrice || '';
      } else {
        if (isAbove === '' || reference === '') {
          return '';
        }
      }
      const { referenceList } = this.settings;
      let str = '';
      let obj = referenceList.find(item => item.id === reference);
      str += isAbove ? this.$t('customize.above') : this.$t('customize.below');
      if (obj && obj.value === 'exinone') {
        str += ` ${this.$t('customize.exinone')} ${difference} CNY`;
      } else {
        str += ` ${obj && obj.text} ${percentage}%`;
      }
      return str;
    },
    tradeAmountText() {
      const { tradeAmountMin, tradeAmountMax } = this.adStore;
      if (!tradeAmountMin || !tradeAmountMin) {
        return '';
      }
      return `${tradeAmountMin} - ${tradeAmountMax}`;
    },
    standardHoursText() {
      const { timeZone, timeStart, timeEnd } = this.adStore;
      const { timeZoneList, timeList } = this.settings;
      if (timeZone === '' || timeStart === '' || timeEnd === '') {
        return '';
      }
      return `${timeZoneList[timeZone].text} ${timeList[timeStart].text}-${timeList[timeEnd].text}`;
    },
    traderText() {
      const { traders } = this.adStore;
      return this.isLoaded
        ? traders.length > 0
          ? this.$t('createPost.selectedTrader')
          : this.$t('createPost.defaultTrader')
        : '';
    },
    optionalModeText() {
      const { isCheck } = this.adStore;
      return this.$t(`createPost.${isCheck ? 'checked' : 'unchecked'}`);
    },
    isBtnDisabled() {
      return this.isSubmitting;
    },
    isEditBtnDisabled() {
      return this.adStore.status !== 'off' || this.isEditSubmitting;
    },
  },
  mounted() {
    const query = this.$route.query;
    if (!query.id) {
      Toast.failed(`${this.$t('error.occur')}${this.$t('error.para')}`);
      return this.$router.back();
    }
    this.id = query.id;
    Toast.loading(this.$t('common.loading'));
    let p1 = Promise.resolve();
    if (!this.settings.isSettingsLoaded) {
      p1 = this.$store.dispatch('updateSettings');
    }
    let p2 = this.$store.dispatch('updateAdStore', { id: this.id }).then(() => {
      this.title = this.adStore.title;
      this.provisions = this.adStore.provisions;
      if (this.adStore.adType === 'sell') {
        this.fieldItemList.splice(1, 0, 'optionalMode');
      }
    });
    Promise.all([p1, p2])
      .then(() => {
        Toast.hide();
        this.isLoaded = true;
      })
      .catch(err => {
        this.isLoaded = true;
        Toast.hide();
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/post/edit') {
      this.$store.commit('setCreateTemp', this.adStore);
    } else {
      this.$store.commit('setAdStore', { isNew: true });
    }
    next();
  },
  methods: {
    getText(key) {
      return this[key];
    },
    onAgreeChange(checked) { //下单前同意风险及用户条例
      this.agreeConf.checked = checked;
    },
    onLossConfirm() { //风险弹窗确认按钮
      if(this.agreeConf.checked == true){
        this.lossDialog.open = false;
        this.onChangeAdStatusBtnClick();
      }
    },
    onChangeClickPre() {
      //添加主网资产受损弹窗
      if(this.adStore.status == 'off'){
        this.lossDialog.open = true;
        return;
      }else{
        this.onChangeAdStatusBtnClick();
      }

    },
    onChangeAdStatusBtnClick() {
      this.isSubmitting = true;
      Toast.loading(this.$t('common.loading'));
      const status = this.adStore.status == 'on' ? 'off' : 'on';
      const msg =
        this.adStore.status == 'on'
          ? this.$t('createPost.TakeOffSuccess')
          : this.$t('createPost.putOnSuccess');
      putChangeStatus(this.id, status)
        .then(() => {
          this.isSubmitting = false;
          Toast.hide();
          Toast.succeed(msg);
          this.$store.commit('setAdStore', { status });
          this.$refs.scrollView && this.$refs.scrollView.scrollTo(0, 0);
        })
        .catch(err => {
          this.isSubmitting = false;
          Toast.hide();
          Dialog.alert({
            icon: 'warn-color',
            title: this.$t('error.occurs'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    goEditAd() {
      this.isEditSubmitting = true;
      this.$nextTick(() => {
        this.isEditSubmitting = false;
        this.$router.push({
          path: '/post/edit',
          query: {
            id: this.id,
          },
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  position: absolute;
  absolute-pos(11.73vw);
}

.scroll-body {
  padding-bottom: 60vw;
}

.info {
  height: 11.07vw;
  margin: 0 4.8vw;
  font-weight: 600;
  font-size: 3.73vw;
  color: #dc521b;
}

.field {
  padding: 6.4vw 0;

  .field-item {
    padding: 0 4.8vw;
    height: 17.07vw;
    font-size: 3.73vw;

    &:nth-child(even) {
      background: #f8fbfc;
    }

    .field-item-title {
      flex: 0 0 32vw;
      font-weight: bold;
    }

    .field-item-content {
      flex: 1 0 0%;
      text-align: right;
      color: #1b6fdc;

      &.inactive {
        color: #bcc7cb;
      }
    }
  }
}

.input-panel {
  padding: 4.8vw 4.8vw 30vw;

  .input-panel-item {
    margin-bottom: 9.6vw;
  }

  .panel-item-title {
    margin-bottom: 4.8vw;
    font-size: 4.8vw;
    font-weight: bold;

    .icon {
      margin-right: 1.07vw;
      icon-size(6.67vw);
    }
  }

  >>> .md-field-item-content:before {
    content: none;
  }

  .input-item {
    border: 0.27vw solid #eaf1f3;
    padding: 0 2.13vw;
    border-radius: 2.67vw;
    background: #f8f8fc;
  }

  .textarea-item {
    padding: 3.2vw 2.13vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
    background: #f8f8fc;
  }
}

.btn-wrapper {
  position: fixed;
  z-index: 100;
  left: 4.8vw;
  right: 4.8vw;
  bottom: 6.4vw;
  margin-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  margin-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */

  .btn-edit {
    margin-top: 4.8vw;
    background: #fff;
  }
}
</style>
